export {
  makeCartProductsList,
  getLedgerMethodsListString,
  getExistingProductWithNotesInCartIdx,
  getSubmissionLabel,
  extractRestockFeeValues,
  getProductPriceFractional,
  isLineAmountValid,
  buildDepositConfig,
  sumTaxLines,
  sumTaxesByRateId,
  interleaveByPosition,
} from "./helpers"

export type { CartLine } from "./helpers"

export {
  getSaleDefaultUomId,
  getSaleUomInfo,
  applySaleUomSelection,
  buildValidatedSaleUomSelection,
  buildReturnUomSnapshot,
  stripSaleProductUomFields,
  useSelectSaleProductUom,
  useSelectSaleProductPricingUom,
} from "./uom"

export type { SaleUomUsage } from "./uom"

export {
  hasZeroQuantitySaleProduct,
  hasOnlyFullyClosedOutProducts,
  isReturn,
  isSpecialOrderSaleProduct,
  isUnlinkedReturn,
} from "./saleProduct"

export {
  getCloseOutStatusDisplay,
  isCartLineRedesignInScope,
  isSaleDepositable,
  isSaleFinalized,
  isSpecialOrderCartLineInScope,
} from "./saleStatus"

export { toShowPricesOption } from "./showPricesOption"
